import React  from "react";

import PropTypes from "prop-types";

import BasePadding from "@cayuse/shared-react.components.base-padding";
import VerticalSpacing from "@cayuse/shared-react.components.vertical-spacing";

import { useEditingContext } from "components/BudgetBuilder/shared/EditingContext";
import PeriodDropdown from "components/BudgetBuilder/shared/PeriodDropdown";

import { ResearchTeamList } from "../../ResearchTeam";
import ExternalCostShareList from "../ExternalCostShare/ExternalCostShareList";
import InternalCostShareList from "../InternalCostShare/InternalCostShareList";
import SummaryList from "../Summary/SummaryList";
import styles from "./styles.css";


const CostShareMainView = () => {
	const { researchTeam, internalCostShare, externalCostShare } = useEditingContext();

	return (
		<div className={styles.budgetSettings}>
			<BasePadding>
				<VerticalSpacing>
					<PeriodDropdown
						disabled={researchTeam[0] || internalCostShare[0] || externalCostShare[0]}
					/>
				</VerticalSpacing>
				<VerticalSpacing>
					<ResearchTeamList isCostShare={true} />
				</VerticalSpacing>
				<VerticalSpacing>
					<InternalCostShareList />
				</VerticalSpacing>
				<VerticalSpacing>
					<ExternalCostShareList />
				</VerticalSpacing>
				<VerticalSpacing>
					<SummaryList />
				</VerticalSpacing>
			</BasePadding>
		</div>
	);
};

CostShareMainView.propTypes = {
	handleFormLoaded: PropTypes.func,
	setFormVariables: PropTypes.func,
	formVariables: PropTypes.object,
};
export default CostShareMainView;
